module.exports = __webpack_public_path__ + "static/media/texture-wood-black.8264bebf.jpg";